// The official Meta Pixel bootstrap snippet, verbatim except that the pixel id
// is injected from configuration instead of hardcoded. It defines the global
// `fbq` queue, loads `fbevents.js` from connect.facebook.net, and fires the
// initial PageView. We only ever render this once marketing consent is granted
// (see `MetaPixel`), so the pixel's `_fbp` cookie is never set beforehand.
//
// The upstream snippet also ships a <noscript> tracking pixel. It is
// deliberately omitted: consent lives in localStorage and can only be read by
// JavaScript, so a <noscript> image would fire for exactly the visitors whose
// choice we cannot know — an unconditional beacon that defeats the gate.
export function metaPixelSnippet(pixelId: string): string {
  return `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', ${JSON.stringify(pixelId)});
fbq('track', 'PageView');`;
}
